var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"font-heading text-2xl font-semibold text-gray-900"},[_vm._v(_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }